import React, { Component } from 'react'

export default class Posts extends Component {
    constructor(props) {
        super(props)
        this.state = {
            new_timesheet_post: null
        }
    }

    activeUpdateRow(activerow, activerow_ind) {
        this.setState({ activerow, activerow_ind })
        if (activerow === 0) {
            this.setState({
                new_timesheet_post: null
            })
        }
        if (this.props.selected_menu === 2 && activerow === 1) {
            const { TimesheetPosts } = this.props
            this.setState({
                new_timesheet_post: TimesheetPosts[activerow_ind].timesheet_post
            })

        }
        this.props.activeUpdateRow(activerow, activerow_ind)
    }
    plusInsertRow(insertRow) {
        this.setState({ insertRow })
        this.setState({
            activerow_ind: -1
        })
        if (insertRow === 0) {
            this.setState({
                new_timesheet_post: null
            })
        }
        this.props.plusInsertRow(insertRow)
    }

    onChangePost = (e) => {
        this.setState({
            new_timesheet_post: e.target.value
        })
    }

    postTimesheetPostsUpdate = (timesheet_post, id_timesheet_post) => {
        this.props.postTimesheetPostsUpdate(timesheet_post, id_timesheet_post)
        setTimeout(() => {
            this.setState({
                new_timesheet_post: null
            })
            this.props.activeUpdateRow(0, -1)
        }, 10);
    }

    postTimesheetPostsInsert = (timesheet_post) => {
        this.props.postTimesheetPostsInsert(timesheet_post)
        setTimeout(() => {
            this.setState({
                new_timesheet_post: null
            })
            this.plusInsertRow(0)
        }, 10);
    }
    render() {
        const { TimesheetPosts } = this.props
        return (
            <div>
                <table >
                    <thead>
                        <tr>
                            <th style={{ width: '70px' }}>№</th>
                            <th style={{ width: '1fr', textAlign: 'center' }}>Название</th>
                            <th style={{ width: '8%' }}>Действие</th>
                        </tr>
                    </thead>
                    <tbody>
                        {TimesheetPosts && TimesheetPosts.length && TimesheetPosts.map((item, index) => (
                            <tr key={'SpecialList' + index} className={this.props.activerow === 1 && this.props.activerow_ind === index && 'insert_row'}>
                                <td>{index + 1}</td>
                                <td style={{
                                    padding: this.props.activerow === 1 && this.props.activerow_ind === index ? '0' : '10px',
                                    verticalAlign: this.props.activerow === 1 && this.props.activerow_ind === index ? 'top' : 'middle'
                                }}>
                                    {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                        <input
                                            type='text'
                                            onChange={this.onChangePost}
                                            defaultValue={item.timesheet_post}
                                        /> : item.timesheet_post
                                    }
                                </td>
                                <td>
                                    {
                                        this.state.new_timesheet_post !== item.timesheet_post && this.props.activerow_ind === index ?
                                            <i className="fas fa-save" onClick={() => this.postTimesheetPostsUpdate(this.state.new_timesheet_post, item.id_timesheet_post)}></i> : null
                                    }
                                    {this.props.activerow === 1 && this.props.activerow_ind === index ?
                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                        <>
                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)} title='Изменить'></i>
                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                        </>}
                                </td>
                            </tr>))}
                        {this.props.insertRow === 1 ?
                            <tr className={this.props.insertRow === 1 && 'insert_row'}>
                                <td>{TimesheetPosts && TimesheetPosts.length + 1}</td>
                                <td style={{ padding: '0', verticalAlign: 'top' }}>
                                    <input
                                        className='Post_input'
                                        type='text'
                                        onChange={this.onChangePost}
                                        placeholder='Введите должность'
                                    />
                                </td>
                                <td>
                                    {this.state.new_timesheet_post ?
                                        <>
                                            <i className="fas fa-save" onClick={() => this.postTimesheetPostsInsert(this.state.new_timesheet_post)}></i>
                                            <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                        </> :
                                        <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                    }
                                </td>
                            </tr> : null
                        }
                        <tr><td className='Plus_row' onClick={() => this.plusInsertRow(1)} title='Добавить'>+</td></tr>

                    </tbody>
                </table>
            </div>
        )
    }
}
